/* @HEADER
 * @version 1.0.1556 | 2026-09-19
 * @purpose Bounded data-testid registry for the BoardNav sidebar tree — stable hooks Playwright specs use to drive the space/board create + select flow.
 * @sidecar board-nav.testids.ts.header.md
 * @layer app | @hex _none_ | @ctx _none_
 * @public true
 * @edit careful
 */

// SpecRefs: ZVX-DEV-6172, ZVX-DEV-6103, ZVX-E2E-002

/** Bounded testid registry for the BoardNav sidebar (spaces tree + inline create). */
export const BOARD_NAV_TESTIDS = {
  /** "+ Пространство" button — opens the inline create input for a new top-level space. */
  newSpaceBtn: 'board-nav-new-space-btn',
  /** Inline input bound to the open create form (single input shared across new-space and new-sub-space contexts). */
  newSpaceInput: 'board-nav-new-space-input',
  /** "+" affordance on a parent space header that opens the inline create input for a sub-space / board. */
  newSubSpaceBtn: (parentId: string) => `board-nav-new-sub-space-btn-${parentId}`,
  /** The pinned «Все задачи организации» aggregate item (ZVX-DEV-6172; the id was a literal in BoardNav before). */
  orgTasksItem: 'org-tasks-nav-item',
  /** Per-space tree node, keyed by board-group id. */
  spaceItem: (spaceId: string) => `board-nav-space-item-${spaceId}`,
  /** "✕" delete-space action on a top-level space row, keyed by board-group id (ZVX-DEV-3520). */
  deleteSpaceBtn: (spaceId: string) => `board-nav-delete-space-btn-${spaceId}`,
  /** Keyboard-reachable neutral opener for the modular Space-settings modal. */
  spaceSettingsBtn: (spaceId: string) => `board-nav-space-settings-btn-${spaceId}`,

  // ── Delete-space dialog (ZVX-DEV-5637) ──────────────────────────────────
  // Added here rather than in a registry of its own: the dialog belongs to the
  // flow this file already covers, and the repository asks for one bounded
  // registry per visible area rather than one per component.
  /** The dialog itself — its absence is «nothing was asked». */
  deleteSpaceDialog: 'space-delete-dialog',
  /** The line naming how many boards the Space holds. */
  deleteSpaceBoardCount: 'space-delete-dialog-board-count',
  /** Destination picker — drawn only when there are boards to move. */
  deleteSpaceDestination: 'space-delete-dialog-destination',
  /** Confirm and cancel. */
  deleteSpaceConfirmBtn: 'space-delete-dialog-confirm',
  deleteSpaceCancelBtn: 'space-delete-dialog-cancel',
} as const;
